export class SlugService {
    getSequencePageURL(slug) {
        return `${slug}/sequence`;
    }

    getPublishPageURL(slug) {
        return `${slug}/publish`;
    }

    getDetailsPageURL(slug) {
        return `${slug}/details`;
    }

    getEditPageURL(slug) {
        return `${slug}/edit`;
    }

    getAddPageURL(slug) {
        return `${slug}/add`;
    }

    getOverviewPageUrl(slug) {
        return `${slug}/overview`;
    }

    removeResourceActionsFromSlugURL(slug, action) {
        return slug.replace(`/${action}`, '');
    }

    getContentDetailsURL(slug, id) {
        return `${slug}/${id}/details`;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/slug/slug.service.js